/**
 * Heading H1, H2, ... 타이틀
 * cjfw-fsmns-mo-pub
 *
 * @author 김정웅
 */
import React from 'react'

// css
import 'assets/style/elements/heading.scss'

function Element({ children, className = '', level = 1, text }) {
  const txt = typeof children === 'undefined' ? text : children
  return [
    txt,
    <h1 className={'heading ' + className}>{txt}</h1>,
    <h2 className={'heading ' + className}>{txt}</h2>,
    <h3 className={'heading ' + className}>{txt}</h3>,
    <h4 className={'heading ' + className}>{txt}</h4>,
    <h5 className={'heading ' + className}>{txt}</h5>,
  ][level]
}

export default Element
